import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FilterContainer from '../components/GenericFilter';
import * as FilterSearchAction from '../actions/filterSearchActions';

function mapStateToProps(state) {
  return {
    ...state.Filter,
    ...state.SaveFilter,
    ...state.FilterField,
    ...state.FilterSearch,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...FilterSearchAction,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterContainer);
